import React, { useCallback, useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import Input from '../../../../components/input'
import ButtonComponent from '../../../../components/button'
import Modal from '../../../../components/modal'
import { Row, Action } from '../../../../components/action-button'
import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { updateCampaign, getCampaignInfo, startCampaign, deleteCampaign, insertCampaignStep, updateCampaignStep, deleteCampaignStep, addCampaignRecipient, deleteCampaignRecipient } from '../../../../api'
import { AuthContext } from '../../../../auth-context'
import { DashboardContext } from '../../dashboard-context'
import { ErrorMessage } from '../../../../components/error-message'
import { SelectUsers } from './select-users'

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`

const CampaignInfoDisplay = styled.div`
  padding: 10px
`

const TableTitle = styled.h2`
  padding: 32px 0 16px 0;
  margin: 0 auto;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`

const Table = styled.table`
  background: #FFF;
  border-spacing: 0px;
  width: 100%;
`

const TableHead = styled.thead`
  color: #FFF;
`

const TableBody = styled.tbody`
`

const TableHeadRow = styled.tr`
`

const TableBodyInsertRow = styled.tr`
  td {
    text-align: left;
  }
`

const InsertAfter = styled.span`
  cursor: pointer;
`

const TableBodyStepRow = styled.tr`
  cursor: pointer;
  &:hover {
    background: #f2f2f2;
  }
`

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${props => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${props => (props.bigWidth) ? '160px' : '100px' };
  padding: 8px;
  position: sticky;
  top: 0;
  z-index: 30;
`

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${props => props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px;
  text-align: center;
`

const ButtonCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-size: .875rem;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`

const ActionButton = styled(ButtonComponent)`
  margin: 0;
  margin-left: 16px;
  min-width: 180px;
`

const WaitTypeSelect = styled(Select)`
  padding: 7px 12px;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 100px;
  background-color: #eaedf5;
  color: #5a5a5a !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 16px !important;
  font-weight: 300 !important;
  &.Mui-focused .MuiSelect-select {
    background-color: #eaedf5;
  }
`

const TextBoxLabel = styled.label`
  color: #676767;
  display: block;
  font-family: ${props => props.theme.font.primary};
  margin-bottom: 8px;
`;

const TextBox = styled.textarea`
  border: 1px solid ${props => props.error ? '#F44336' : '#DDDEE8'};
  border-radius: 4px;
  color: #5a5a5a;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 300;
  margin-bottom: 16px;
  min-height: 310px;
  padding: 12px;
  transition: 0.2s ease border, 0.2s ease box-shadow;
  width: 100%;

  &:hover {
    border: 1px solid ${props => props.error ? '#F44336' : ' #1890ff'};
  }

  &:focus {
    border: 1px solid ${props => props.error ? '#F44336' : ' #1890ff'};
    box-shadow: 0px 0px 0px 3px ${props => props.error ? '#FFBBB6D1' : ' #b1dfffa6'};
    outline: none;
  }
`;

const Campaign = (props) => {
  const campaignId = Number(props.match.params.id)
  const { openSnackbar } = useContext(DashboardContext);
  const { user } = useContext(AuthContext)
  const [campaignInfoState, updateCampaignInfoState] = useState(0)
  const [campaignInfo, updateCampaignInfo] = useState(null)
  const [showRenameModal, updateShowRenameModal] = useState(false)
  const [showStartModal, updateShowStartModal] = useState(false)
  const [showDeleteModal, updateShowDeleteModal] = useState(false)
  const [showAddRecipientsModal, updateShowAddRecipientsModal] = useState(false)
  const [showStepModal, updateShowStepModal] = useState(false)
  const [newName, updateNewName] = useState('')
  const [newNameError, updateNewNameError] = useState(false)
  const [stepId, updateStepId] = useState(0)
  const [after, updateAfter] = useState(0)
  const [waitType, updateWaitType] = useState(0)
  const [waitDuration, updateWaitDuration] = useState('')
  const [waitDurationError, updateWaitDurationError] = useState(false)
  const [waitUntilTime, updateWaitUntilTime] = useState('')
  const [waitUntilTimeError, updateWaitUntilTimeError] = useState(false)
  const [message, updateMessage] = useState('')
  const [error, updateError] = useState('')
  const [loading, updateLoading] = useState(false)

  const calculateTimes = (ci) => {
    let newSteps = []
    if (ci.state === 0) {
      let currentTime = new Date()
      if (currentTime.getSeconds() !== 0 || currentTime.getMilliseconds() !== 0) {
        currentTime.setMinutes(currentTime.getMinutes() + 1, 0, 0)
      }
      for (let n = 0; n < ci.steps.length; ++n) {
        switch (ci.steps[n].wait_type) {
          case 0:
            break

          case 1:
            currentTime = new Date(currentTime.valueOf() + ci.steps[n].wait_duration * 60000)
            break

          case 2:
            currentTime = new Date(currentTime.valueOf() + ci.steps[n].wait_duration * 3600000)
            break

          case 3:
            const minutes = ci.steps[n].wait_until_time % 60
            const hours = (ci.steps[n].wait_until_time - minutes) / 60
            currentTime = new Date(currentTime.valueOf() + ci.steps[n].wait_duration * 86400000)
            currentTime.setHours(hours, minutes, 0, 0)
            break

          default:
        }
        const sendAtObj = new Date(currentTime.valueOf())
        newSteps.push(Object.assign({}, ci.steps[n], { send_at_obj: sendAtObj }))
      }
    } else {
      for (let n = 0; n < ci.steps.length; ++n) {
        const sendAtObj = new Date(ci.steps[n].send_at)
        newSteps.push(Object.assign({}, ci.steps[n], { send_at_obj: sendAtObj }))
      }
    }
    return Object.assign({}, ci, { steps: newSteps })
  }

  const fetchCampaignInfo = useCallback(() => {
    updateCampaignInfoState(1)
    return getCampaignInfo(user.id, campaignId).then((res) => {
      updateCampaignInfo(calculateTimes(res.data))
      updateCampaignInfoState(2)
    })
  }, [user.id, campaignId])

  useEffect(() => {
    if (campaignInfoState === 0 && user.id) {
      fetchCampaignInfo()
    }
  }, [campaignInfoState, user.id, fetchCampaignInfo])

  const handleRename = () => {
    updateNewName(campaignInfo.name)
    updateNewNameError(false)
    updateError('')
    updateShowRenameModal(true)
  }

  const doRename = () => {
    if (newName === '') {
      updateError('Please enter a new name for the campaign.')
      updateNewNameError(true)
    } else {
      const lcName = newName.toLowerCase()
      let duplicate = false
      for (let n = 0; n < campaignInfo.other_campaign_names.length; ++n) {
        if (campaignInfo.other_campaign_names[n].toLowerCase() === lcName) {
          duplicate = true
          break
        }
      }
      if (duplicate) {
        updateError('Another campaign already has that name.')
        updateNewNameError(true)
      } else {
        updateLoading(true)
        updateCampaign(user.id, campaignId, newName).then((res) => {
          fetchCampaignInfo().then((res) => {
            openSnackbar('Campaign successfully renamed.', false)
            updateNewNameError(false)
            updateError('')
            updateLoading(false)
            updateShowRenameModal(false)
          })
        })
      }
    }
  }

  const handleAddRecipients = () => {
    updateShowAddRecipientsModal(true)
  }

  const handleCloseAddRecipients = () => {
    updateShowAddRecipientsModal(false)
  }

  const doAddRecipients = (recipients) => {
    if (recipients.length === 0) {
      updateShowAddRecipientsModal(false)
    } else {
      addCampaignRecipient(user.id, campaignId, recipients).then((res) => {
        openSnackbar((recipients.length === 1 ? '1 recipient' : recipients.length + ' recipients') + ' successfully added.', false)
        updateShowAddRecipientsModal(false)
        fetchCampaignInfo()
      })
    }
  }

  const handleCloseStepModal = () => {
    updateShowStepModal(false)
  }

  const handleStart = () => {
    updateShowStartModal(true)
  }

  const doStart = () => {
    updateLoading(true)
    const revisedCampaignInfo = calculateTimes(campaignInfo)
    let times = []
    for (let n = 0; n < revisedCampaignInfo.steps.length; ++n) {
      times.push(revisedCampaignInfo.steps[n].send_at_obj.valueOf())
    }
    startCampaign(user.id, campaignId, times).then((res) => {
      openSnackbar('Campaign successfully started.', false)
      props.history.push('/dashboard/campaigns')
    })
  }

  const handleDelete = () => {
    updateShowDeleteModal(true)
  }

  const doDelete = () => {
    updateLoading(true)
    deleteCampaign(user.id, campaignId).then((res) => {
      openSnackbar('Campaign successfully deleted.', false)
      props.history.push('/dashboard/campaigns')
    })
  }

  const handleDone = () => {
    props.history.push('/dashboard/campaigns')
  }

  const handleStepClick = (step) => {
    const minutes = step.wait_until_time % 60
    const hours = (step.wait_until_time - minutes) / 60
    let minutesStr = minutes.toString()
    if (minutesStr.length === 1) {
      minutesStr = '0' + minutesStr
    }
    updateStepId(step.id)
    updateAfter(0)
    updateWaitType(step.wait_type)
    updateWaitDuration(step.wait_duration.toString())
    updateWaitDurationError(false)
    updateWaitUntilTime(hours + ':' + minutesStr)
    updateWaitUntilTimeError(false)
    updateMessage(step.message)
    updateError('')
    updateShowStepModal(true)
  }

  const handleInsertAfterClick = (sequence_number) => {
    updateStepId(0)
    updateAfter(sequence_number)
    updateWaitType(0)
    updateWaitDuration('0')
    updateWaitDurationError(false)
    updateWaitUntilTime('0:00')
    updateWaitUntilTimeError(false)
    updateMessage('')
    updateError('')
    updateShowStepModal(true)
  }

  const handleWaitTypeChange = (e) => {
    updateWaitType(Number(e.target.value))
  }

  const filterEmoji = (emoji) => {
    return !(emoji.name === 'White Smiling Face' || emoji.name === 'White Frowning Face')
  }

  const handleEmojiSelect = (emoji) => {
    if (emoji.native) {
      updateMessage(message + emoji.native)
    }
  }

  const doSaveStep = () => {
    const digitsTest = /^[0-9]+$/
    let newWaitDuration = 0
    let newWaitUntilTime = 0
    let waitDurationLabel = ''
    let errorFound = false
    switch (waitType) {
      case 1:
        waitDurationLabel = '# Minutes'
        break

      case 2:
        waitDurationLabel = '# Hours'
        break

      case 3:
        waitDurationLabel = '# Days'
        break

      default:
    }
    if (waitDurationLabel !== '') {
      if (!(digitsTest.test(waitDuration))) {
        updateError(waitDurationLabel + ' must be a whole number.')
        updateWaitDurationError(true)
        errorFound = true
      } else {
        newWaitDuration = parseInt(waitDuration)
        if (newWaitDuration === 0) {
          updateError(waitDurationLabel + ' must be greater than 0.')
          updateWaitDurationError(true)
          errorFound = true
        }
      }
    }
    if (waitType === 3 && !errorFound) {
      let x = waitUntilTime.trim().toLowerCase()
      let am = false
      let pm = false
      if (x.length >= 2 && x.slice(x.length - 2) === 'am') {
        am = true
        x = x.slice(0, x.length - 2).trim()
      } else if (x.length >= 2 && x.slice(x.length - 2) === 'pm') {
        pm = true
        x = x.slice(0, x.length - 2).trim()
      } else if (x.length >= 8 && x.slice(x.length - 8) === 'midnight') {
        am = true
        x = x.slice(0, x.length - 8).trim()
        if (x === '' || x === '12' || x === '12:00') {
          x = '12'
        } else {
          updateError('Then Send At must be a valid time of day.')
          updateWaitUntilTimeError(true)
          errorFound = true
        }
      } else if (x.length >= 4 && x.slice(x.length - 4) === 'noon') {
        pm = true
        x = x.slice(0, x.length - 4).trim()
        if (x === '' || x === '12' || x === '12:00') {
          x = '12'
        } else {
          updateError('Then Send At must be a valid time of day.')
          updateWaitUntilTimeError(true)
          errorFound = true
        }
      }
      if (!errorFound) {
        let z = '0'
        let j = x.indexOf(':')
        if (j !== -1) {
          z = x.slice(j + 1)
          x = x.slice(0, j)
        }
        if (!(digitsTest.test(x)) || !(digitsTest.test(z))) {
          updateError('Then Send At must be a valid time of day.')
          updateWaitUntilTimeError(true)
          errorFound = true
        } else {
          const h = parseInt(x)
          const m = parseInt(z)
          if (h >= 24 || m >= 60 || ((am || pm) && (h < 1 || h > 12))) {
            updateError('Then Send At must be a valid time of day.')
            updateWaitUntilTimeError(true)
            errorFound = true
          } else if (am) {
            newWaitUntilTime = (h === 12 ? 0 : h) * 60 + m
          } else if (pm) {
            newWaitUntilTime = (h === 12 ? 12 : h + 12) * 60 + m
          } else {
            newWaitUntilTime = h * 60 + m
          }
        }
      }
    }
    if (!errorFound) {
      if (message === '') {
        updateError('Please enter the message.')
        errorFound = true
      }
    }
    if (!errorFound) {
      if (stepId === 0) {
        insertCampaignStep(user.id, campaignId, after, waitType, newWaitDuration, newWaitUntilTime, message).then((res) => {
          fetchCampaignInfo().then((res) => {
            openSnackbar('Step successfully inserted.', false)
            updateShowStepModal(false)
          })
        })
      } else {
        updateCampaignStep(user.id, campaignId, stepId, waitType, newWaitDuration, newWaitUntilTime, message).then((res) => {
          fetchCampaignInfo().then((res) => {
            openSnackbar('Step successfully updated.', false)
            updateShowStepModal(false)
          })
        })
      }
    }
  }

  const doDeleteStep = () => {
    deleteCampaignStep(user.id, campaignId, stepId).then((res) => {
      fetchCampaignInfo().then((res) => {
        openSnackbar('Step successfully deleted.', false)
        updateShowStepModal(false)
      })
    })
  }

  const handleDeleteRecipient = (recipient) => {
    deleteCampaignRecipient(user.id, campaignId, recipient.id).then((res) => {
      openSnackbar('Recipient successfully deleted.', false)
      fetchCampaignInfo()
    })
  }

  const formatTiming = (step) => {
    let result

    switch (step.wait_type) {
      case 0:
        result = 'immediate'
        break

      case 1:
        result = 'wait ' + (step.wait_duration === 1 ? '1 minute' : step.wait_duration + ' minutes')
        break

      case 2:
        result = 'wait ' + (step.wait_duration === 1 ? '1 hour' : step.wait_duration + ' hours')
        break

      case 3:
        const minutes = step.wait_until_time % 60
        const hours = (step.wait_until_time - minutes) / 60
        let minutesStr = minutes.toString()
        if (minutesStr.length === 1) {
          minutesStr = '0' + minutesStr
        }
        result = 'wait ' + (step.wait_duration === 1 ? '1 day' : step.wait_duration + ' days') + ', then send at ' + hours + ':' + minutesStr
        break

      default:
        result = '?'
    }

    return result
  }

  const formatMessage = (message) => {
    const LIMIT = 20
    let result = message

    if (message.length > LIMIT) {
      let chosenLength = LIMIT
      const lastUtf16 = message.charCodeAt(chosenLength - 1)
      if (lastUtf16 >= 55296 && lastUtf16 <= 56319) {
        ++chosenLength
      }
      result = message.slice(0, chosenLength) + '...'
    }

    return result
  }
  const currentSelected = []
  user.accounts.forEach((a) => {
    if (a.user_id !== null && (a.manager_id === user.id || a.trainers.includes(user.id)) && a.trainer_permission === 1) {
      let already = false
      for (let n = 0; n < campaignInfo?.recipients.length; ++n) {
        if (campaignInfo?.recipients[n].id === a.id) {
          already = true
          break
        }
      }
      if (already) {
        currentSelected.push({id: a.id, email_address: a.email_address, name: a.name, trainers: a.trainers})
      }
    }
  })

  return campaignInfoState !== 2 ? (
    <React.Fragment>
      <Container className={props.className}>
        <CircularProgress size={32} />
      </Container>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Container>
        <h2>Campaign</h2>
        <CampaignInfoDisplay>
          <p>Campaign ID: {campaignInfo.id}</p>
          <p>Name: {campaignInfo.name}</p>
          <p># Steps: {campaignInfo.step_count}</p>
          <p># Recipients: {campaignInfo.recipient_count}</p>
          <p>State: {campaignInfo.state === 0 ? 'draft' : (campaignInfo.state === 2 ? 'completed' : ((campaignInfo.last_sequence_number === 1 ? '1 step' : campaignInfo.last_sequence_number + ' steps') + ' done'))}</p>
        </CampaignInfoDisplay>
        <ButtonContainer>
          <ActionButton
            label="Rename"
            onClick={handleRename}
          />
          <ActionButton
            label="Add Recipients"
            onClick={handleAddRecipients}
          />
          {campaignInfo.step_count !== 0 && campaignInfo.recipient_count !== 0 && campaignInfo.state === 0 && (
            <ActionButton
              label="Start"
              onClick={handleStart}
            />
          )}
          <ActionButton
            label="Delete"
            onClick={handleDelete}
          />
          <ActionButton
            label="Done"
            onClick={handleDone}
          />
        </ButtonContainer>
        <TableTitle>Steps</TableTitle>
        <Table>
          <TableHead>
            <TableHeadRow>
              <HeadCell>Timing</HeadCell>
              <HeadCell>Message</HeadCell>
              <HeadCell>Send at</HeadCell>
              <HeadCell>Result</HeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {campaignInfo.state === 0 && (
              <TableBodyInsertRow>
                <DataCell><InsertAfter onClick={() => handleInsertAfterClick(0)} title="Insert step"><AddIcon /></InsertAfter></DataCell>
                <DataCell></DataCell>
                <DataCell></DataCell>
                <DataCell></DataCell>
              </TableBodyInsertRow>
            )}
            {campaignInfo.steps.map((entry, index) => {
              return (
                <React.Fragment key={entry.id}>
                  <TableBodyStepRow onClick={() => handleStepClick(entry)}>
                    <DataCell>{formatTiming(entry)}</DataCell>
                    <DataCell>{formatMessage(entry.message)}</DataCell>
                    <DataCell>{entry.send_at_obj.toString().slice(0, 21)}</DataCell>
                    <DataCell>{entry.sent ? (entry.recipient_count === 1 ? 'sent to 1 recipient' : 'sent to ' + entry.recipient_count + ' recipients') : ''}</DataCell>
                  </TableBodyStepRow>
                  {campaignInfo.state === 0 && (
                    <TableBodyInsertRow>
                      <DataCell><InsertAfter onClick={() => handleInsertAfterClick(entry.sequence_number)} title="Insert step"><AddIcon /></InsertAfter></DataCell>
                      <DataCell></DataCell>
                      <DataCell></DataCell>
                      <DataCell></DataCell>
                    </TableBodyInsertRow>
                  )}
                </React.Fragment>
              )
            })}
          </TableBody>
        </Table>
        <TableTitle>Recipients</TableTitle>
        <Table>
          <TableHead>
            <TableHeadRow>
              <HeadCell>Email Address</HeadCell>
              <HeadCell>Full Name</HeadCell>
              <HeadCell>Actions</HeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {campaignInfo.recipients.map((entry, index) => {
              return (
                <TableBodyRow key={entry.id}>
                  <DataCell>{entry.email_address}</DataCell>
                  <DataCell>{entry.name}</DataCell>
                  <ButtonCell>
                    <Row>
                      <Action
                        icon={<DeleteIcon />}
                        iconColor='#da0f0f'
                        text="Delete"
                        onClick={() => handleDeleteRecipient(entry)}
                      />
                    </Row>
                  </ButtonCell>
                </TableBodyRow>
              )
            })}
          </TableBody>
        </Table>
        <Modal
          title={`Rename Campaign`}
          message={`Please enter the new name for this campaign.`}
          submitLabel="Rename"
          open={showRenameModal}
          onClose={() => updateShowRenameModal(false)}
          handleSubmit={doRename}
          warning
          disabled={loading}
          isLoading={loading}
        >
          <Input
            error={newNameError}
            label="New Name"
            value={newName}
            onChange={updateNewName}
          />

          {error !== '' && 
            <ErrorMessage>
              {error}
            </ErrorMessage>
          }
        </Modal>
        <Modal
          title={`Start Campaign`}
          message={`Are you sure you want to start this campaign?`}
          submitLabel="Start"
          open={showStartModal}
          onClose={() => updateShowStartModal(false)}
          handleSubmit={doStart}
          warning
          disabled={loading}
          isLoading={loading}
        >
          <h4>{campaignInfo.name}</h4>
        </Modal>
        <Modal
          title={`Delete Campaign`}
          message={`Are you sure you want to delete this campaign?`}
          submitLabel="Delete"
          open={showDeleteModal}
          onClose={() => updateShowDeleteModal(false)}
          handleSubmit={doDelete}
          warning
          disabled={loading}
          isLoading={loading}
        >
          <h4>{campaignInfo.name}</h4>
        </Modal>
        <SelectUsers
          currentSelected={currentSelected}
          submit={doAddRecipients}
          open={showAddRecipientsModal}
          onClose={handleCloseAddRecipients}
        />
        <Dialog className='weigh-in-dialog' maxWidth="lg" fullWidth={true} open={showStepModal} onClose={handleCloseStepModal}>
          <DialogContent className='avn-modal-content-container' style={{overflowY: 'visible'}}>
            <div style={{margin: '20px 0 10px 0'}}>
              <label>{stepId === 0 ? 'Insert' : 'Update'} Step</label>
            </div>
            <div style={{width: '100%', textAlign: 'left'}}>
              <InputLabel id="wait-type-select-label" style={{color: '#676767', fontFamily: '"DM Sans", sans-serif', fontSize: '14px', fontWeight: '700', marginBottom: '8px'}}>Wait Type</InputLabel>
              <WaitTypeSelect value={waitType} labelId="wait-type-select-label" label="Wait Type" disableUnderline onChange={handleWaitTypeChange} disabled={campaignInfo.state !== 0}>
                <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={0}>Immediate</MenuItem>
                <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={1}>Wait Minutes</MenuItem>
                <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={2}>Wait Hours</MenuItem>
                <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={3}>Wait Days</MenuItem>
              </WaitTypeSelect>
              {waitType !== 0 && (
                <>
                  <Input
                    error={waitDurationError}
                    label={'# ' + (waitType === 1 ? 'Minutes' : (waitType === 2 ? 'Hours' : 'Days'))}
                    value={waitDuration}
                    onChange={updateWaitDuration}
                    disabled={campaignInfo.state !== 0}
                  />
                  {waitType === 3 && (
                    <>
                      <Input
                        error={waitUntilTimeError}
                        label={'Then Send At'}
                        value={waitUntilTime}
                        onChange={updateWaitUntilTime}
                        disabled={campaignInfo.state !== 0}
                        info={`Example: 3:30PM or 15:30`}
                      />
                    </>
                  )}
                </>
              )}
              <div style={{display: 'flex', flexWrap: 'wrap'}}>
                <div style={{display: 'inline-block', width: '888px', paddingRight: '10px'}}>
                  <TextBoxLabel htmlFor=''>Message (use [name] for first name of recipient)</TextBoxLabel>
                  <TextBox 
                    value={message}
                    onChange={(e) => updateMessage(e.target.value)}
                    disabled={campaignInfo.state !== 0}
                  />
                </div>
                <div style={{display: 'inline-block', width: '353px'}}>
                  {campaignInfo.state === 0 && (
                    <Picker data={data} onEmojiSelect={handleEmojiSelect} previewPosition="none" theme="light" />
                  )}
                </div>
              </div>
              {error !== '' && 
                <ErrorMessage>
                  {error}
                </ErrorMessage>
              }
            </div>
          </DialogContent>
          <DialogActions className='avn-modal-actions-container'>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              {campaignInfo.state === 0 && (
                <Button style={styles.addRecipientsButton} onClick={doSaveStep}>Save</Button>
              )}
              <Button style={styles.closeButton} onClick={handleCloseStepModal}>{campaignInfo.state === 0 ? 'Cancel' : 'Close'}</Button>
              {campaignInfo.state === 0 && stepId !== 0 && (
                <Button style={styles.deleteButton} onClick={doDeleteStep}>Delete</Button>
              )}
            </div>
          </DialogActions>
        </Dialog>
      </Container>
    </React.Fragment>
  )
}

const styles = {
  addRecipientsButton: {
    background: '#4cb050',
    borderRadius: '3px',
    color: 'white',
    margin: '0 5px'
  },
  closeButton: {
    background: '#cccc',
    borderRadius: '3px',
    color: 'white',
    margin: '0 5px'
  },
  deleteButton: {
    background: '#ff0000',
    borderRadius: '3px',
    color: 'white',
    margin: '0 5px'
  },
}

export default withRouter(Campaign)